import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Box, Typography, Button } from '@mui/material';

const NotAuthorized = ({ ownerEmail }) => {
    const navigate = useNavigate();
    useEffect(() => {
        const timer = setTimeout(() => {
            navigate('/Dashboard');
        }, 4000);
        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <Box sx={{ textAlign: 'center', mt: 8 }}>
            <Typography variant="h4" color="error" gutterBottom>
                You are not authorized to view this page.
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
                Please contact your account owner{ownerEmail ? ` at ${ownerEmail}` : ''} to allow you access.
            </Typography>
            <Button variant="contained" color="primary" onClick={() => navigate('/Dashboard')}>Go to Home</Button>
        </Box>
    );
};

export default NotAuthorized;
